import { host_haiji_url } from '@/api/host'
var couponApi = {
    //通用优惠券
    getGeneralCouponUrl: `${host_haiji_url}/v2/admin/coupons`,//获取通用优惠券
    deGeneralCouponUrl: `${host_haiji_url}/v1/admin/coupons`,//删除优惠券
    addGeneralCoupon: `${host_haiji_url}/v2/admin/coupons`, // 添加优惠卷
    editGeneralCoupon: `${host_haiji_url}/v2/admin/coupons`, // 编辑优惠卷
    enableCouponUrl: `${host_haiji_url}/v1/admin/coupons/enable`,//启用优惠券
    disableCouponUrl: `${host_haiji_url}/v1/admin/coupons/disable`,//停用优惠券
    //优惠券列表
    getCouponListUrl: `${host_haiji_url}/v1/admin/user_gifts/type/coupons`,//获取优惠券列表
    invalidCouponUrl: `${host_haiji_url}/v1/admin/user_gifts/expire`,//失效优惠券
    exportCouponUrl: `${host_haiji_url}/v1/admin/user_gifts/type/coupons/export`,//获取用户优惠券列表导出 http://projectdoc.epetbar.com/web/#/177?page_id=4615
};

export { couponApi }